import { render, staticRenderFns } from "./ArticleQuick.vue?vue&type=template&id=19bcae32&scoped=true"
import script from "./ArticleQuick.vue?vue&type=script&lang=js"
export * from "./ArticleQuick.vue?vue&type=script&lang=js"
import style0 from "./ArticleQuick.vue?vue&type=style&index=0&id=19bcae32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bcae32",
  null
  
)

export default component.exports